import { render, staticRenderFns } from "./CompanyDistrictDeliverySpaceList.vue?vue&type=template&id=d14cdf52&"
import script from "./CompanyDistrictDeliverySpaceList.vue?vue&type=script&lang=ts&"
export * from "./CompanyDistrictDeliverySpaceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports